import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
  }, []);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleViewAccount = () => {
    navigate('/dashboard/app/user-account-setting');
  };

  return (
    <div id='content-page' className='content-page'>
      <Container>
        <Row>
          
          <Col md={8} className="mx-auto mt-4">
            <Paper elevation={3} sx={{ p: 5, borderRadius: 2, textAlign: 'center' }}>
              <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'success.main', mb: 3 }} />
              
              <Typography variant="h4" gutterBottom>
                {t("Payment success!")}
              </Typography>
              
              <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                {t("We have received your payment. Your subscription is now active and you can enjoy all the features included in your plan.")}
              </Typography>
              
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                {t("A confirmation email has been sent to the address associated with your account.")}
              </Typography>
              
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Button 
                  variant="contained" 
                  color="primary"
                  onClick={handleGoHome}
                  sx={{ px: 4, py: 1.5 }}
                >
                  {t("Back to home")}
                </Button>
                
                <Button 
                  variant="outlined" 
                  color="primary"
                  onClick={handleViewAccount}
                  sx={{ px: 4, py: 1.5 }}
                >
                  {t("View my account")}
                </Button>
              </Box>
            </Paper>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentSuccess;
